module.exports = __webpack_public_path__ + "./Luffy_33c5ade334baa68628af1f9eab881edc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/Luffy.jpg
// module id = 496
// module chunks = 0